import React, { useEffect, useRef, useState } from 'react'
import Script from 'react-load-script'
import { handleUrls } from './helpers'
import type { ISocialBlockProps, IYandexShare, IYaShareReturnType } from './types'

declare const window: {
  Ya?: IYandexShare
} & Window

const SocialShareBlock: React.FC<ISocialBlockProps> = props => {
  const { contentToShare, services, theme } = props

  const { baseUrl, image, url } = contentToShare

  const socialHtmlRef = useRef<HTMLDivElement>(null)
  const yandexBlockRef = useRef<Maybe<IYaShareReturnType>>(null)

  const [isScriptLoaded, setIsScriptLoaded] = useState(false)
  const [isScriptLoadingError, setIsSriptLoadingError] = useState(false)

  const handledServices = services.join(',')
  const { punnycode: vkContent } = handleUrls({ baseUrl, imageUrl: image, publicationUrl: url })

  useEffect(() => {
    if (yandexBlockRef.current || !socialHtmlRef.current || !isScriptLoaded || isScriptLoadingError || !window.Ya) return

    yandexBlockRef.current = window.Ya.share2(socialHtmlRef.current, {
      content: contentToShare,
      contentByService: {
        vkontakte: { ...contentToShare, ...vkContent },
      },
      theme,
    })

    // eslint-disable-next-line consistent-return
    return () => {
      if (yandexBlockRef.current) {
        yandexBlockRef.current.destroy()
        yandexBlockRef.current = null
      }
    }
  }, [contentToShare, isScriptLoaded, isScriptLoadingError, theme, vkContent])

  const onError = () => {
    setIsSriptLoadingError(true)
  }

  const onLoad = () => {
    if (!isScriptLoaded) setIsScriptLoaded(true)
    if (!('Ya' in window)) setIsSriptLoadingError(true)
  }

  if (isScriptLoadingError) return null

  return (
    <>
      <Script url={'https://yastatic.net/share2/share.js'} onError={onError} onLoad={onLoad} />
      <div ref={socialHtmlRef} data-services={handledServices} />
    </>
  )
}

export default SocialShareBlock
